import React, { useRef } from 'react';
import { Button, Row } from 'reactstrap';
import { faArrowLeft, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Context
import { useAuth } from '../../../../context/auth';
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import mascaras from '../../../../helpers/mascaras';

//Estilo da pagina de impressão
const pageStyle = `
@media print {
  @page{
    size: A4;
    margin: 0.5rem;
  }

  body { 
    -webkit-print-color-adjust: exact; 
  } 

  .relatorio {
    width: 100vw !important;
    display:flex !important;
    flex-direction: column !important;
    padding: 0px 15px !important;
  }

  div.header{
    display:table-header-group;
  }

  div.body{
    display:table-row-group;
  }

  .noPrint{
    display: none;
  }
}
`;

function CertificadoEntregaComunicacaoEletronica({
  dadosExtracao,
  dadosInfracao,
  impressaoDividaAtivaPDF
}) {
  const { session, logoSistema, logoSecretaria, dadosSecretaria, logoPrefeitura } = useAuth();

  //Referencia para o componente de impressão
  const ref = useRef(null);

  const json = JSON.parse(dadosExtracao?.json);

  //Função assionada assim que o botão de imprimir pdf é clicado
  const handlePrint = useReactToPrint({
    content: () => ref.current,
    documentTitle: "Certificado de Entrega de Comunicação Eletrônica",
    pageStyle: pageStyle
  });


  return <>
    <div className={`break ${impressaoDividaAtivaPDF ? "bg-white" : "relatorio"} shadowFicha mainContainerFicha p-4`}>
      {!impressaoDividaAtivaPDF &&
        <div className='d-flex align-items-center justify-content-end'>
          <div className='d-flex gap-2'>
            <Button color='danger' onClick={handlePrint}>
              <FontAwesomeIcon icon={faFilePdf} /> Imprimir
            </Button>
          </div>
        </div>}

      <div className="mt-4 w-100" ref={ref}>
        <div className={`print m-2 d-flex align-items-center justify-content-between`}>
          <p>Emitido por: {session?.nome}</p>
          <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
        </div>

        <div className='d-flex justify-content-between align-items-center w-100'>
          {logoSecretaria &&
            <div>
              {logoSecretaria && <img src={logoSecretaria} className='mt-3' width={140} alt="logo do sistema" />}
            </div>
          }
          <div className='mt-5' style={{ textAlign: 'center' }}>
            <h5><b>PREFEITURA DO MUNICÍPIO DE {String(dadosSecretaria?.prefeitura).toUpperCase()}</b></h5>
            <h5><b>{String(dadosSecretaria?.descricao).toUpperCase()}</b></h5>
          </div>
          <div>
            {logoPrefeitura && <img src={logoPrefeitura} width={210} alt="logo da prefeitura" />}
          </div>
        </div>
        <div className="header">
          <Row>
            <div className='col-12 mt-3'>
              <h5 className='rounded-3 bg-secondary text-light p-2'>CERTIFICADO DE ENTREGA DE COMUNICAÇÃO ELETRÔNICA</h5>
            </div>
            <div className='w-100 d-flex align-items-center justify-content-between gap-4 my-2'>
              <span><b>Número da Infração: </b>{dadosInfracao?.numeroInfracao}</span>
              <span><b>Nome do Infrator: </b>{dadosInfracao?.infrator?.nome}</span>
              <span><b>Tipo de Documento: </b>{dadosInfracao?.infrator?.tipoDocumentoIdentificacao}</span>
              <span><b>Documento Identificação: </b>{dadosInfracao?.infrator?.documentoIdentificacao ? mascaras.cpfcnpjMask(dadosInfracao?.infrator?.documentoIdentificacao) : ""}</span>
            </div>
            <div>
              <span>
                <p>Certificamos para os devido fins, que: <br></br> No dia <b>{moment(json?.mail?.commonHeaders?.date).locale('pt-br').format("D [de] MMMM [de] YYYY")},</b> às <b>{moment(json?.mail?.commonHeaders?.date).format("HH:mm")} (horário de Brasília)</b>, foi enviada comunicação eletrônica com o seguinte conteúdo:</p>

                <ul>
                  {json?.mail?.commonHeaders?.from?.[0] && (
                    <li><b>Remetente: </b>{String(json?.mail?.commonHeaders?.from[0]).split("<")[0]}</li>
                  )}
                  {json?.mail?.commonHeaders?.to?.[0] && (
                    <li><b>Destinatário: </b>{json?.mail?.commonHeaders?.to[0]}</li>
                  )}
                  {json?.mail?.commonHeaders?.subject && (
                    <li><b>Assunto: </b>{json?.mail?.commonHeaders?.subject}</li>
                  )}
                  {json?.mail?.messageId && (
                    <li><b>Mensagem-ID: </b>{json?.mail?.messageId}</li>
                  )}
                  {json?.mail?.commonHeaders?.date && (
                    <li><b>Data e hora de envio: </b>{moment(json?.mail?.commonHeaders?.date).format("DD/MM/YYYY HH:mm:ss")}</li>
                  )}
                </ul>

                <p>A entrega da mensagem foi confirmada pelo provedor de envio com as seguintes informações técnicas: <br></br></p>
                <ul>
                  {(json?.delivery?.reportingMTA || json?.open?.reportingMTA) && (
                    <li><b>Servidor de envio: </b>{json?.delivery?.reportingMTA ?? json?.open?.reportingMTA}</li>
                  )}
                  {(json?.delivery?.remoteMtaIp || json?.open?.remoteMtaIp) && (
                    <li><b>Endereço IP do servidor de destino: </b>{json?.delivery?.remoteMtaIp ?? json?.open?.remoteMtaIp}</li>
                  )}
                  {(json?.delivery?.smtpResponse || json?.open?.smtpResponse) && (
                    <li><b>Resposta do servidor de destino (SMTP): </b>{json?.delivery?.smtpResponse ?? json?.open?.smtpResponse}</li>
                  )}
                  {(json?.delivery?.processingTimeMillis || json?.open?.processingTimeMillis) && (
                    <li><b>Tempo de processamento:</b> {json?.delivery?.processingTimeMillis ?? json?.open?.processingTimeMillis} milissegundos</li>
                  )}
                  {(json?.delivery?.timestamp || json?.open?.timestamp) && (
                    <li><b>Confirmação de entrega registrada às:</b> {moment(json?.delivery?.timestamp ?? json?.open?.timestamp).format("DD/MM/YYYY HH:mm:ss")}</li>
                  )}
                </ul>

                <p>A mensagem foi enviada por meio do serviço Amazon Simple Email Service (SES), com autenticação do domínio <b>{String(json?.mail?.source).split("@")[1]}</b>, utilizando conexão segura com protocolo TLSv1.2 e TLSv1.3 para envio e recepção, respectivamente.</p>

                <br></br>
                <p><b>Importância da Comunicação:</b></p>
                <p>A presente comunicação possui natureza oficial e urgente, tendo sido emitida com prioridade máxima e marcação de notificação de leitura solicitada ao destinatário.</p>

                <br></br>
                <hr></hr>

                <div style={{ textAlign: 'center' }}>
                  <p><b>{dadosSecretaria?.prefeitura}, {moment().locale('pt-br').format("D [de] MMMM [de] YYYY")}</b></p>
                </div>

                <hr></hr>

                <div style={{ textAlign: 'center' }}>
                  <p>{dadosSecretaria?.descricao} – {dadosSecretaria?.prefeitura}.</p>
                  <p>{dadosSecretaria?.endereco}</p>
                </div>
              </span>
            </div>
          </Row>
        </div>
      </div >
    </div>
  </>;
}

export default CertificadoEntregaComunicacaoEletronica;